// extracted by mini-css-extract-plugin
export default {"reviewCount":"review-summary_reviewCount__ws1Hv","menuItem":"review-summary_menuItem__ll0lf"};